import {createInstance} from '@datapunt/matomo-tracker-react';
// import APP_CONFIG from '../configs/config.json'
import APP_CONFIG from 'src/utils/matomoConfig'

class AnalyticsService {
  constructor() {
    if(AnalyticsService.instance) {
      return AnalyticsService.instance
    }
    AnalyticsService.instance = this;
  }

  initializeAnalyticsClient() {
    if(APP_CONFIG.ANALYTICS.active === false) {
      return null
    }
    this.matomo_instance = createInstance(APP_CONFIG.ANALYTICS.matomo_configuration);
    return this.matomo_instance;
  }

  trackPageView(page_title) {
    if(this.matomo_instance) {
      this.matomo_instance?.trackPageView({documentTitle: page_title});
    }
  }
}

const analytics_service = new AnalyticsService();
export {analytics_service};